export const envs = [
  {
    name: "Production",
    value: "prd",
  },
  {
    name: "Test",
    value: "tst",
  },
];

export const webhooks = [
  {
    name: "No authentication",
    value: "no-auth",
  },
  {
    name: "Basic Auth (username / password)",
    value: "basic",
  },
  {
    name: "API key HTTP header (header name / header value)",
    value: "api-key",
  },
  {
    name: "OAuth 2.0 (client ID / client secret)",
    value: "oauth2",
  },
];

export const webHookStructure = {
  auth: null,
  url: "",
  username: "",
  password: "",
  identity: "",
  secret: "",
  authUrl: "",
  oauthSecretName: "",
  oauthSecret: "",
  urlHeaders: {},
  corelations: {},
  authHeaders: {},
};
